import { Skeleton } from './components/Skeleton';
import { Menu } from './components/Menu';
import { Policy } from './components/Policy';
import styles from './Footer.module.scss';

export const Footer = ({ uiBlocks }) => {
  const upFooter = !!uiBlocks ? uiBlocks.find((el) => el.id === 89) : false;
  const upContact = !!uiBlocks ? uiBlocks.find((el) => el.id === 104) : false;

  if (!upFooter && !upContact) {
    return (
      <footer className={styles.footer}>
        <Skeleton />
      </footer>
    );
  }

  return (
    <footer className={styles.footer}>
      <Menu upFooter={upFooter} upContact={upContact} />
      <Policy />
    </footer>
  );
};
